import { combineReducers } from "redux";
import * as types from "../types";
import { userReducer } from "./user";
import userWheelsReducer from "./wheels";
import categoryReducer from "./categoryColors";
import colorReducer from "./userColors";
import { referralsReducer } from "./referrals";
import { analyticsReducer } from "./analytics";
import settingsReducer from "./segmentSettings";
import wallpapersReducer from "./wallpapers";
import wheelWallpaperReducer from "./wheelWallpaper";
import builderReducer from "./builder";
import segmentBuilder from "./segmentBuilder";
import deleteDialogReducer from "./dialog";
import moveBlockDialogReducer from "./moveBlockDialog";
import galleryReducer from "./gallery";
import generalDialog from "./generalDialog";
import betaTimeoutPopup from "./betaTimeoutPopup";
import codeblockDefaultStylesReducer from "./PrevStylesCopy/CodeblockDefaultStyles";
import wheelSettings from "./wheelSettings";
import galleryPopup from "./galleryPopup";
import hotbarReducer from "./newhotbar";
import colorPalette from "./colorPalette";
import createWheelPopupReducer from "./createWheelPopup";
import storageReducer from "./storage";
import notificationsSlice from "./notifications";
import dialogPopup from "./dialogPopup";
import upgradePopup from "./upgradePopup";
import aiWheelsReducer from "./aiWheels";
import subscriptionReducer from "./subscription";
import mobileViewDialogReducer from "./mobileViewDialog";
import nonAuthenticatedModalReducer from "./nonAuthenticatedModal";

const appReducer = combineReducers({
  userProfile: userReducer,
  userWheels: userWheelsReducer,
  categoryColors: categoryReducer,
  userColors: colorReducer,
  referrals: referralsReducer,
  analytics: analyticsReducer,
  segmentSettings: settingsReducer,
  wallpapersReducer: wallpapersReducer,
  wheelWallpaperReducer: wheelWallpaperReducer,
  wheel: builderReducer,
  segmentBuilder: segmentBuilder,
  deleteDialog: deleteDialogReducer,
  moveBlockDialog: moveBlockDialogReducer,
  mobileViewDialog: mobileViewDialogReducer,
  gallery: galleryReducer,
  generalDialog: generalDialog,
  betaTimeoutPopup: betaTimeoutPopup,
  codeblockStyles: codeblockDefaultStylesReducer,
  wheelSettings,
  galleryPopup: galleryPopup,
  hotbar: hotbarReducer,
  colorPalette: colorPalette,
  createWheelPopup: createWheelPopupReducer,
  storage: storageReducer,
  notifications: notificationsSlice,
  dialogPopup,
  upgradePopup,
  aiWheels: aiWheelsReducer,
  subscription: subscriptionReducer,
  nonAuthenticatedModal: nonAuthenticatedModalReducer,
});

// EW-1004: on LOGOUT, reset EVERY slice to its initial state. Previously only
// user/referrals/wheels handled LOGOUT, so subscription/analytics/storage/
// notifications (and the rest) retained the prior user's data in memory AND in
// the redux-persist `persist:root` blob — a shared-device next-user could read
// it. Resetting the whole tree also defeats any re-persist race after
// persistor.purge() (see purgePersistedState in ../index.js): even if the
// persistor re-writes after purge, it now writes only initial state.
const rootReducer = (state, action) => {
  if (action.type === types.LOGOUT) {
    // Pass undefined so every combined reducer falls back to its initial state.
    // redux-persist's `_persist` key is managed by persistReducer OUTSIDE this
    // reducer, so it is untouched here.
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
